module.exports = __webpack_public_path__ + "static/media/mia-khalifa.46f9323f.jpg";